import { Text, Tooltip } from 'bold-ui'
import { DateTime } from 'components/date'
import { format } from 'date-fns'
import { HistoricoMedicaoModel } from 'view/atendimentos/types/model-historicoMedicao'

export type MedicaoResult = { medicao: string | number; tooltip?: string }

type MedicaoRenderer = (medicoes: HistoricoMedicaoModel) => JSX.Element

const getTooltipMedicao = (medicoes: HistoricoMedicaoModel): string => {
  if (medicoes.origem === 'antecedente') return 'Medições ao nascer'
  if (medicoes.dataRegistro)
    return `Registrado por ${medicoes.nomeResponsavel} - ${format(new Date(medicoes.dataRegistro), 'dd/MM/yyyy')}`
  return 'Registrado no atendimento atual'
}

const TooltipMedicao = (props: { medicoes: HistoricoMedicaoModel; children: React.ReactElement; tooltip?: string }) => {
  const { tooltip, medicoes } = props
  const tooltipText = tooltip ?? getTooltipMedicao(medicoes)

  return <Tooltip text={tooltipText}>{props.children}</Tooltip>
}

export const renderMedicao = (
  medicaoGetter: (x: HistoricoMedicaoModel) => MedicaoResult,
  tooltip?: string
): MedicaoRenderer => (medicoes) => {
  const resultado = medicaoGetter(medicoes)

  const isObject = typeof resultado === 'object' && !!resultado
  const valorExibido = isObject ? resultado.medicao : resultado
  const tooltipFinal = isObject ? resultado.tooltip ?? tooltip : tooltip

  return (
    <TooltipMedicao medicoes={medicoes} tooltip={tooltipFinal}>
      <Text component='p'>{valorExibido ?? '-'}</Text>
    </TooltipMedicao>
  )
}

export const renderDataHoraMedicao = (medicoes: HistoricoMedicaoModel) => (
  <TooltipMedicao medicoes={medicoes}>
    <Text component='p' style={{ margin: '0.5rem 0' }}>
      <DateTime
        value={medicoes.dataMedicao}
        format={`DD/MM/YYYY ${medicoes.origem === 'medicoesAnteriores' ? '' : 'HH:mm'}`}
      />
      {medicoes.origem === 'medicoesAnteriores' && (
        <Text component='span' style={{ fontStyle: 'italic' }}>
          Reg. tardio
        </Text>
      )}
    </Text>
  </TooltipMedicao>
)

export const renderDataMedicao = (medicoes: HistoricoMedicaoModel) => (
  <TooltipMedicao medicoes={medicoes}>
    <Text component='p' style={{ margin: '0.5rem 0' }}>
      <DateTime value={medicoes.dataMedicao} format={`DD/MM/YYYY`} />
    </Text>
  </TooltipMedicao>
)
